import Leaderboard from "./components/Leaderboard/Leaderboard";
import "./App.css";
import React from "react";

function App() {
  return (
    <React.Fragment>
      <Leaderboard />
    </React.Fragment>
  );
}

export default App;
